import { RootState } from "..";

export const selectLanguage = (state: RootState) => state.app.language;

export const selectVisitId = (state: RootState) => state.app.visitId;
